import {LastSyncedUpstreamValue} from 'notebook/structured-tables/StructuredTableConstants';
import {Cell} from 'notebook/tables/TableConstants';

// Keep in sync with get_updated_cell_with_lsuv in benchling/notebook/structured_tables/resync/cell_update.py
export function getUpdatedCellWithLSUV(
  columnProvenanceUuid: string,
  oldCell: Cell,
  lastSyncedUpstreamValues: Array<LastSyncedUpstreamValue> | null | undefined
): Cell {
  const lsuvTypedValue = lastSyncedUpstreamValues?.find(
    (value) => value.columnProvenanceUuid === columnProvenanceUuid
  )?.value;
  return {...oldCell, ...(lsuvTypedValue ? {typedValue: lsuvTypedValue} : {})};
}
